import {Observable} from "rxjs";
import {WrapperDto} from "../dto/wrapper.dto";
import {UserDto} from "../dto/user.dto";
import {inject, Injectable} from "@angular/core";
import {EmailDto} from "../dto/email.dto";
import {DuckDbHelper} from "./duckdb.helper";
import {OrgUserDto} from "../dto/org-user.dto";
import {UserRepo} from "../api/user.repo";
import {map} from "rxjs/operators";
import {State} from "../../libs/enum/state.enum";
import {isDefined} from "../../libs/utils/epic.utils";
import {OverviewDto} from "../dto/overview-dto";
import {SettingDto} from "../dto/setting.dto";
import {SettingKey} from "../../base/setting-key.enum";
import {OrgDuckDb} from "./org.duckdb";
import {AccStateEnum} from "../../services/state/acc-state.enum";
import {VoidDto} from "../dto/void.dto";

@Injectable({providedIn: 'root'})
export class UserDuckDb extends UserRepo {

  private readonly orgRepo = inject(OrgDuckDb);
  private readonly duck = inject(DuckDbHelper);
  private user: UserDto | undefined;
  private orgUser: OrgUserDto | undefined;
  private settings: SettingDto[] | undefined;

  // noinspection JSUnusedGlobalSymbols
  public override readSelf(): Observable<WrapperDto<UserDto>> {
    if (isDefined(this.user)) {
      return DuckDbHelper.dataObs('UserDto', this.user);
    }

    return this.orgRepo.readById('').pipe(map((res) => {
      const org = res.getFirstData();
      this.user = new UserDto({
        id: '420b0d13-b92f-4b3a-906a-005ce824780e',
        enabled: true,
        languageCode: org.languageCode,
        countryCode: org.countryCode,
        firstname: 'Backup',
        lastname: '',
        timezone: org.timezone,
        emails: [new EmailDto({
          id: 'ac0d2bfa-80bb-4703-9d4d-4d3ff59fd250',
          email: 'backup@localhost',
          prime: true,
          newsletter: false,
          verified: true,
        })]
      });
      return DuckDbHelper.data('UserDto', this.user);
    }));
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public override readAssignedOrgs(_user: UserDto): Observable<WrapperDto<OrgUserDto>> {
    if (isDefined(this.orgUser)) {
      return DuckDbHelper.dataObs('OrgUserDto', this.orgUser);
    }
    return this.orgRepo.readById('').pipe(map((res) => {
      const org = res.getFirstData();
      this.orgUser = new OrgUserDto({
        id: '27f9d672-a383-4c76-974f-8a712ca66735',
        enabled: true,
        state: State.CONFIRMED,
        email: 'backup@localhost',
        userId: '420b0d13-b92f-4b3a-906a-005ce824780e',
        fullName: 'Backup',
        org: org
      });
      return DuckDbHelper.data('OrgUserDto', this.orgUser);
    }));
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public override getOverview(_user: UserDto): Observable<WrapperDto<OverviewDto>> {
    const overview = new OverviewDto({assignedOrgCount: 1});
    return DuckDbHelper.dataObs('OverviewDto', overview);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public override readSettings(_user: UserDto): Observable<WrapperDto<SettingDto>> {
    if (isDefined(this.settings)) {
      return DuckDbHelper.datasObs('SettingDto', this.settings);
    }
    return this.orgRepo.readById('').pipe(map((res) => {
      const org = res.getFirstData();
      this.settings = [
        new SettingDto({key: SettingKey.USER_OVERVIEW_ORDER, value: '{}'}),
        new SettingDto({key: SettingKey.USER_LAST_STATE, value: AccStateEnum.ORG}),
        new SettingDto({key: SettingKey.USER_LAST_ORG, value: org.id}),
      ];
      return DuckDbHelper.datas('SettingDto', this.settings);
    }));
  }

  public override updateSettings(_user: UserDto, settings: SettingDto[]): Observable<WrapperDto<SettingDto>> {
    this.settings = settings;
    return this.readSettings(_user);
  }

  public override ping(): Observable<WrapperDto<VoidDto>> {
    return DuckDbHelper.dataObs('VoidDto', new VoidDto());
  }
}
